module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 'canvas'),
      expression: "type === 'canvas'"
    }],
    ref: "canvas",
    style: ({
      height: _vm.size,
      width: _vm.size
    }),
    attrs: {
      "height": _vm.size,
      "width": _vm.size
    }
  }), _vm._v(" "), (_vm.type === 'img') ? _c('img', {
    attrs: {
      "src": _vm.imgData
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d193854e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/qrcode/index.vue
// module id = 538
// module chunks = 1